import React, { useEffect, useState } from 'react'
import { CartesianGrid, Legend, Line, LineChart, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts'

function ConversationFlow({conversation_data}) {

  const [domainValue, setDomainValue] = useState(null)
  const [lineGraphShow, setLineGraphShow] = useState("general")

  function changeDisplayedGraph(lineGraph){
    setLineGraphShow(lineGraph)

    if(lineGraph === "general"){
      getDomain("general")
    }else if(lineGraph === "message_length"){
      getDomain("message_length")
    }else if(lineGraph === "turn_taking_rate"){
      getDomain("turn_taking_rate")
    }else if(lineGraph === "question_frequency"){
      getDomain("question_frequency")
    }else if(lineGraph === "command_frequency"){
      getDomain("command_frequency")
    }else{
      getDomain("general")
    }

  }

  function getDomain(lineDomain) {

    const new_list = conversation_data && conversation_data.flatMap(x => {

      if(lineDomain === "general"){
        return [
          x.avg_message_length,
          x.question_frequency,
          x.turn_taking_rate,
          x.command_frequency
      ]
      }else if(lineDomain === "message_length"){
        return [x.avg_message_length]
      }else if(lineDomain === "turn_taking_rate"){
        return [x.turn_taking_rate]
      }else if(lineDomain === "question_frequency"){
        return [x.question_frequency]
      }else if(lineDomain === "command_frequency"){
        return [x.command_frequency]
      }else{
        return [0,1]
      }

    })

 
    const min = Math.min(...new_list)
    const max = Math.max(...new_list)

    return {min, max}
  }

  useEffect(() => {
    setDomainValue(getDomain(lineGraphShow))

    // eslint-disable-next-line 
  },[lineGraphShow])



  return (
    <div className='text-black'>
    <h3 className="text-lg font-semibold mb-4">Conversation Flow Metrics</h3>
    <div className='flex px-3 my-5 space-x-4 rounded-md'>
      <button 
      className={`
      px-3 py-2 rounded-md
      ${lineGraphShow === "general" ? "bg-black text-white" : "bg-gray-500 text-black"}
      `}
      onClick={() => {
        changeDisplayedGraph("general")
      }}>
      General
      </button>

      <button
      className={`
      px-3 py-2 rounded-md
      ${lineGraphShow === "message_length" ? "bg-black text-white" : "bg-gray-500 text-black"}
      `}
      onClick={() => {
        changeDisplayedGraph("message_length")
      }}>Message Length</button>
      
      <button
      className={`
      px-3 py-2 rounded-md
      ${lineGraphShow === "turn_taking_rate" ? "bg-black text-white" : "bg-gray-500 text-black"}
      `}
      onClick={() => {
        changeDisplayedGraph("turn_taking_rate")
      }}>Turn Taking</button>

      <button
      className={`
      px-3 py-2 rounded-md
      ${lineGraphShow === "question_frequency" ? "bg-black text-white" : "bg-gray-500 text-black"}
      `}
      onClick={() => {
        changeDisplayedGraph("question_frequency")
      }}>Question Freq.</button>

      <button
      className={`
      px-3 py-2 rounded-md
      ${lineGraphShow === "command_frequency" ? "bg-black text-white" : "bg-gray-500 text-black"}
      `}
      onClick={() => {
        changeDisplayedGraph("command_frequency")
      }}>Command Freq.</button>
    </div>


    {domainValue &&
      <ResponsiveContainer width="100%" height={300} margin={{ top: 5, right: 30, left: 10, bottom: 5 }}>
      <LineChart data={conversation_data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="timestamp" />
        <YAxis type='number' domain={[domainValue.min, domainValue.max]}/>
        <Tooltip  />
        <Legend />
        {lineGraphShow === "general" ?
        <React.Fragment>
        <Line type="monotone" dataKey="avg_message_length" stroke="#8884d8" name="Message Length"  />
        <Line type="monotone" dataKey="turn_taking_rate" stroke="#82ca9d"  name="Turn Taking Rate" />
        <Line type="monotone" dataKey="question_frequency" stroke="#ffc658" name="Question Frequency" />
        <Line type="monotone" dataKey="command_frequency" stroke="#ff7300" name="Command Frequency" />
        </React.Fragment>
        :
        lineGraphShow === "message_length" ?
        <Line type="monotone" dataKey="avg_message_length" stroke="#8884d8" name="Message Length"  />
        :
        lineGraphShow === "turn_taking_rate" ?
        <Line type="monotone" dataKey="turn_taking_rate" stroke="#82ca9d"  name="Turn Taking Rate" />
        :
        lineGraphShow === "question_frequency" ?
        <Line type="monotone" dataKey="question_frequency" stroke="#ffc658" name="Question Frequency" />
        :
        lineGraphShow === "command_frequency" ?
        <Line type="monotone" dataKey="command_frequency" stroke="#ff7300" name="Command Frequency" />
        :
        null
        }

      </LineChart>
    </ResponsiveContainer>
     }

    </div>
  )
}

export default ConversationFlow
